import Ajax from "@vvg/forum/js/mixins/ajax";

export default {
	mixins: [Ajax],
	methods: {
		buildReactionsUrl(params) {
			let searchParams = new URLSearchParams(params);
			return `${this.$page.props.forum_url}retrieve_reactions/?${searchParams.toString()}`;
		},
		buildChildReactionsUrl(params) {
			let searchParams = new URLSearchParams(params);
			return `${this.$page.props.forum_url}retrieve_child_reactions/?${searchParams.toString()}`;
		},
		insertReactionLocally(list, reaction) {
			// Backend sorteert op created_at oplopend, dus nieuwe reactie hoort achteraan
			let createdAt = new Date(reaction.created_at).getTime();
			let insertIndex = list.findIndex(item => new Date(item.created_at).getTime() > createdAt);

			if (insertIndex === -1) {
				list.push(reaction);
			} else {
				list.splice(insertIndex, 0, reaction);
			}
		},
		updateReactionLocally(list, reaction) {
			let index = list.findIndex(item => item.id === reaction.id);
			if (index !== -1) {
				list.splice(index, 1, reaction);
			}
			return index !== -1;
		},
		removeReactionLocally(list, reactionId) {
			let index = list.findIndex(item => item.id === reactionId);
			if (index !== -1) {
				list.splice(index, 1);
			}
			return index !== -1;
		},
		handleReactionChange(list, payload, callbacks = {}) {
			if (!payload) {
				return;
			}

			if (payload.action === 'deleted') {
				let removed = this.removeReactionLocally(list, payload.reaction.id);
				if (removed && callbacks.onDeleted) {
					callbacks.onDeleted(payload);
				}
			} else if (payload.action === 'updated') {
				let updated = this.updateReactionLocally(list, payload.reaction);
				if (updated && callbacks.onUpdated) {
					callbacks.onUpdated(payload);
				}
			} else if (payload.action === 'child_added' && callbacks.onChildAdded) {
				callbacks.onChildAdded(payload);
			}
		},
	}
}